import React from "react";
import PropTypes from "prop-types";

import styles from "./StatusIcon.css";
import classNames from "classnames";
import withTooltip from "components/library/Tooltip/withTooltip";

import { STATUS, getStatusFromSlug } from "config/constants";

/**
 * @param {string} [hasTooltip=true] - should icon have tooltip, set w defaultProps
 */
class StatusIcon extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const statusObject = getStatusFromSlug(this.props.status);
    if (this.props.hasTooltip && statusObject) {
      this.props.setTooltipText(statusObject.label);
    }
  }

  render() {
    const statusObject = getStatusFromSlug(this.props.status);
    let statusIcon = null;
    if (statusObject) {
      statusIcon = (
        <div
          className={classNames(styles.root, styles[statusObject.className])}
        ></div>
      );
    }

    return statusIcon;
  }
}

StatusIcon.defaultProps = { hasTooltip: true };

StatusIcon.propTypes = {
  status: PropTypes.oneOf(Object.values(STATUS).map(x => x.slug)),
  hasTooltip: PropTypes.bool,
};

export default withTooltip(StatusIcon);
